
import React from 'react'

export const Subtitle = ({ name, containerClassname }) => {
    return <div className={`pb-0 ${containerClassname}`}>
        <div className='col-12 mt-2'> <h5 className='border-bottom pb-1'>{name}</h5></div>
    </div>
}
